import { useEffect, useState } from 'react';
import { Copy } from '../../copy/Copy';
import { fetchGPTResponse } from '../../helpers/fecthGPTResponse';

export const useChatGPT = (prompt) => {
  const [response, setResponse] = useState();
  const [isLoading, setIsLoading] = useState(true);

  const [messages, setMessages] = useState([
    {
      role: 'system',
      content: Copy.generate('GPT.prompts.init'),
    },
    {
      role: 'user',
      content: `${Copy.generate('GPT.prompts.40words')} ${prompt}`,
    },
  ]);

  useEffect(() => {
    const generateResponse = async () => {
      try {
        const res = await fetchGPTResponse(messages);
        const data = await res.json();

        setResponse(data.choices[0].message.content);
        setMessages((messages) => [...messages, data.choices[0].message]);
        setIsLoading(false);
      } catch (error) {
        console.error(error);
      }
    };

    if (prompt) {
      generateResponse();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const generateMore = async () => {
    setIsLoading(true);

    setMessages((messages) => [
      ...messages,
      {
        role: 'user',
        content: Copy.generate('GPT.prompts.generateMore'),
      },
    ]);

    try {
      const res = await fetchGPTResponse(messages);
      const data = await res.json();

      setResponse(data.choices[0].message.content);
      setMessages((messages) => [...messages, data.choices[0].message]);
      setIsLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  return {
    response,
    isLoading,
    generateMore,
  };
};
